import request from "@/axios";
/** 分页查询退款订单的接口 */
export const getList = params => {
  return request({
    url: `/lebo-vod/vod/refundOrder/page`,
    method: "get",
    params
  });
};
/** 确认退款的接口 */
export const confirmRefund = data => {
  return request({
    url: `/lebo-vod/vod/refundOrder/review`,
    method: "post",
    data
  });
};
/** 获取明细的接口 */
export const getDetail = id => {
  return request({
    url: `/lebo-vod/vod/refundOrder/getById`,
    method: "get",
    params: {
      id
    }
  });
};
/** 退款订单导出接口 */
export const exportRefundOrder = params => {
  return request({
    url: `/lebo-vod/vod/refundOrder/exportExcel`,
    method: "get",
    params,
    responseType: "blob"
  });
};
